/**
 * @Description 益禾堂预估销售额详情
 * https://confluence.lanhanba.com/pages/viewpage.action?pageId=132271748
 */

import { FC } from 'react';
import { Col } from 'antd';
import {
  estimateSalesReasonableSelectYHT,
  estimateSalesSafetySelectYHT,
  estimateSalesUpLimitSelectYHT,
  estimateSalesUpLimitYHT,
  insiderEstimateSalesYHT,
  meituanCompetitorAverageYHT,
  meituanCompetitorMaxYHT,
} from '@/common/components/business/DynamicComponent/config';
import { isArray, isNotEmpty } from '@lhb/func';
import { useMethods } from '@lhb/hook';
// import cs from 'classnames';
// import styles from './entry.module.less';
import V2DetailItem from '@/common/components/Feedback/V2DetailItem';


const EstimateSalesYHTDetail: FC<any> = ({
  textValue
}) => {
  const methods = useMethods({
    getShowVal: (target: any, val: string) => {
      const { options } = target || {};
      if (isArray(options) && options.length) {
        const targetOption = options.find((item) => item.value === target[val]);
        return targetOption?.detailShowVal || '-';
      }
      return '-';
    }
  });
  return (
    <>
      <Col span={12}>
        <V2DetailItem
          label={estimateSalesUpLimitYHT.label}
          value={`${isNotEmpty(textValue?.[estimateSalesUpLimitYHT.keyValue]) ? `${textValue[estimateSalesUpLimitYHT.keyValue]}元` : '-'}`}
        />
      </Col>
      <Col span={12}>
        <V2DetailItem
          label={insiderEstimateSalesYHT.label}
          value={`${isNotEmpty(textValue?.[insiderEstimateSalesYHT.keyValue]) ? `${textValue[insiderEstimateSalesYHT.keyValue]}元` : '-'}`}
        />
      </Col>
      <Col span={12}>
        <V2DetailItem
          label={meituanCompetitorAverageYHT.label}
          value={`${isNotEmpty(textValue?.[meituanCompetitorAverageYHT.keyValue]) ? `${textValue[meituanCompetitorAverageYHT.keyValue]}元` : '-'}`}
        />
      </Col>
      <Col span={12}>
        <V2DetailItem
          label={meituanCompetitorMaxYHT.label}
          value={`${isNotEmpty(textValue?.[meituanCompetitorMaxYHT.keyValue]) ? `${textValue[meituanCompetitorMaxYHT.keyValue]}元` : '-'}`}
        />
      </Col>
      <Col span={12}>
        <V2DetailItem
          label={estimateSalesUpLimitSelectYHT.label}
          value={methods.getShowVal(textValue, estimateSalesUpLimitSelectYHT.keyValue)}
        />
      </Col>
      <Col span={12}>
        <V2DetailItem
          label={estimateSalesReasonableSelectYHT.label}
          value={methods.getShowVal(textValue, estimateSalesReasonableSelectYHT.keyValue)}
        />
      </Col>
      <Col span={12}>
        <V2DetailItem
          label={estimateSalesSafetySelectYHT.label}
          value={methods.getShowVal(textValue, estimateSalesSafetySelectYHT.keyValue)}
        />
      </Col>
    </>
  );
};

export default EstimateSalesYHTDetail;
